import { PrimeNGConfigType } from 'primeng/config';
import { CustomPreset } from './theme/theme';

export const primeNGConfig: PrimeNGConfigType = {
  translation: {
    dateFormat: 'dd/mm/yy',
    dayNamesMin: ['do', 'lu', 'ma', 'me', 'gi', 've', 'sa'],
    monthNames: [
      'gennaio',
      'febbraio',
      'marzo',
      'aprile',
      'maggio',
      'giugno',
      'luglio',
      'agosto',
      'settembre',
      'ottobre',
      'novembre',
      'dicembre',
    ],
    monthNamesShort: [
      'gen',
      'feb',
      'mar',
      'apr',
      'mag',
      'giu',
      'lug',
      'ago',
      'set',
      'ott',
      'nov',
      'dic',
    ],
    today: 'oggi',
    clear: 'annulla',
  },
  theme: {
    preset: CustomPreset,
    options: {
      darkModeSelector: 'false',
      cssLayer: {
        name: 'primeng',
        order: 'tailwind-base, primeng, tailwind-utilities',
      },
    },
  },
};
